import React from 'react';
import { Card, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const SSOCallbackPage: React.FC = () => {
  return (
    <Card className="shadow-lg">
      <div className="text-center py-8">
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
          size="large"
        />
        <h2 className="text-xl font-semibold mt-6">Processing SSO Login</h2>
        <p className="text-muted-foreground">Please wait while we authenticate your session...</p>
      </div>
    </Card>
  );
};

export default SSOCallbackPage;